module.exports = __webpack_public_path__ + "img/BWP.a651a321.svg";